import { useEffect } from "react";
import { useLocation } from "react-router-dom";

let activeId = null;

export const track = (name, params = {}) => {
  if (activeId && typeof window.gtag === "function") window.gtag("event", name, params);
};

export function useAnalytics(id) {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (!id) return;
    activeId = id;
    window[`ga-disable-${id}`] = false;
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    const s = document.createElement("script");
    s.id = "ga-gtag";
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
    document.head.appendChild(s);
    window.gtag("js", new Date());
    window.gtag("config", id, { send_page_view: false });
    return () => {
      window[`ga-disable-${id}`] = true;
      document.querySelectorAll('script[src*="googletagmanager.com/gtag/js"]').forEach((el) => el.remove());
      activeId = null;
      delete window.gtag;
    };
  }, [id]);
  useEffect(() => {
    if (!id) return;
    const t = setTimeout(() => track("page_view", { page_path: pathname + search, page_location: window.location.href, page_title: document.title }), 400);
    return () => clearTimeout(t);
  }, [id, pathname, search]);
}
